import { Component, OnInit, OnChanges, OnDestroy, Input, SimpleChanges, SimpleChange } from '@angular/core';
import { timer } from 'rxjs';
import { ResourceManager } from 'src/app/classes/general/resource-manager';

@Component({
  selector: 'blink-span',
  templateUrl: './blink-span.component.html',
  styleUrls: ['./blink-span.component.scss'],
})
export class BlinkSpanComponent implements OnInit, OnChanges, OnDestroy {
  @Input()
  text: string;
  /**
   * blink (toggle on state change)
   */
  @Input()
  toggle: boolean;
  /**
   * blink (absolute)
   */
  @Input()
  set: boolean;
  /**
   * blink (toggle on state change) for a finite amount of time
   */
  @Input()
  toggleTimeout: boolean;
  /**
   * blink (absolute) for a finite amount of time
   */
  @Input()
  setTimeout: boolean;
  /**
   * blink (absolute) for a finite amount of time, on state transition
   */
  @Input()
  setTimeoutOnChange: boolean;

  @Input()
  baseClass: string;

  @Input()
  defaultClass: string;

  @Input()
  highClass: string;

  blinkEnable: boolean = false;
  state: boolean = false;
  timerSub = null;
  blinkTimeout = null;

  textBaseClass: string = "";
  textDefaultClass: string = "";
  textHighClass: string = "";

  constructor() {

  }

  ngOnChanges(changes: SimpleChanges) {
    // console.log(changes);
    let keys: string[] = Object.keys(changes);
    for (let i = 0; i < keys.length; i++) {
      const chg: SimpleChange = changes[keys[i]];
      // console.log(chg);
      if (!chg.isFirstChange() || chg.currentValue === true) {
        // skip the first change only if the current value is not already set to true
        // this may happen if the button is just shown and it is set to blink
        switch (keys[i]) {
          case 'toggle':
            this.blinkEnable = !this.blinkEnable;
            this.setBlink(false);
            break;
          case 'toggleTimeout':
            // only start blinking
            // the timeout will take care of the rest
            if (!this.blinkEnable) {
              this.blinkEnable = true;
              this.setBlink(true);
            }
            break;
          case 'set':
            this.blinkEnable = chg.currentValue;
            this.setBlink(false);
            break;
          case 'setTimeout':
            this.blinkEnable = chg.currentValue;
            if (this.blinkEnable) {
              // start blinking and timeout
              this.setBlink(true);
            } else {
              // stop blinking on demand
              this.disableBlink();
            }
            break;
          case 'setTimeoutOnChange':
            this.blinkEnable = true;
            this.disableBlink();
            this.setBlink(true);
            break;
        }
      }
      // const chg: SimpleChange = changes[keys[i]];
      // console.log('prev value: ', chg.previousValue);
      // console.log('got name: ', chg.currentValue);
    }
  }

  setBlink(timeout: boolean) {
    if (this.blinkEnable) {
      this.enableBlink(timeout ? 5 : 0);
      if (timeout) {
        this.blinkTimeout = setTimeout(() => {
          this.blinkEnable = false;
          this.disableBlink();
        }, 5500);
      }
    } else {
      this.disableBlink();
    }
  }

  enableBlink(count: number) {
    if (!this.timerSub) {
      let timer1 = timer(0, 500);
      let flagCount: boolean = ((count != null) && (count > 0));
      let countk: number = count * 2;
      this.timerSub = timer1.subscribe(() => {
        this.state = !this.state;
        if (flagCount) {
          countk -= 1;
          if (countk <= 0) {
            this.disableBlink();
          }
        }
      }, (err: Error) => {
        console.error(err);
      });
    }
  }

  disableBlink() {
    this.timerSub = ResourceManager.clearSub(this.timerSub);
    this.blinkTimeout = ResourceManager.clearTimeout(this.blinkTimeout);
    this.state = false;
  }


  ngOnInit() {

    // check base class
    if (this.baseClass) {
      this.textBaseClass = this.baseClass;
    }

    // set defaults
    this.textDefaultClass = this.textBaseClass + " text-color-primary";
    this.textHighClass = this.textBaseClass + " text-color-primary-high";

    // check custom specs

    if (this.defaultClass) {
      this.textDefaultClass = this.textBaseClass + " " + this.defaultClass;
    }

    if (this.highClass) {
      this.textHighClass = this.textBaseClass + " " + this.highClass;
    }

    if (this.set) {
      this.blinkEnable = true;
      this.setBlink(false);
    }
  }

  ngOnDestroy() {
    this.timerSub = ResourceManager.clearSub(this.timerSub);
    this.blinkTimeout = ResourceManager.clearTimeout(this.blinkTimeout);
  }
}
